import loadable from '@loadable/component';

// 懒加载组件
const ImplantableDeliveryManagement = loadable(() => import('./implantableDeliveryManagement/ImplantableDeliveryManagement'));
const ImplantableDeliveryDetailModify = loadable(() => import('./implantableDeliveryManagement/implantableDeliveryDetailModify/ImplantableDeliveryDetailModify'));
const DeliveryQuery = loadable(() => import('./deliveryQuery2308/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery2308/deliveryModify/DeliveryModify'));
const StockupDeliveryQuery = loadable(() => import('./stockupDeliveryQuery2308/StockupDeliveryQuery'));
const StockupDeliveryModify = loadable(() => import('./stockupDeliveryQuery2308/stockupDeliveryModify/StockupDeliveryModify'));

const akzxCstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/akzxCstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));

const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ImplantationOrderManagement = loadable(() => import('./implantationOrderManagement/ImplantationOrderManagement'));
const ImplantationDeliveryDetailQuery = loadable(() => import('./implantationDeliveryDetailQuery/ImplantationDeliveryDetailQuery'));
const AKZXImplantableDeliveryManagement = loadable(() => import('./akzxImplantableDeliveryManagement/ImplantableDeliveryManagement'));
const AKZXImplantableDeliveryDetailModify = loadable(() => import('./akzxImplantableDeliveryManagement/implantableDeliveryDetailModify/ImplantableDeliveryDetailModify'));
const OperationImplantationQuery = loadable(() => import('./operationImplantationQuery/OperationImplantationQuery'));
const OperationImplantationDetailModify = loadable(() => import('./operationImplantationQuery/operationImplantationDetailModify/OperationImplantationDetailModify.js'));
const FreeOrderManagement = loadable(() => import('./freeOrderManagement/FreeOrderManagement'));
const FreeDeliveryQuery = loadable(() => import('./freeDeliveryQuery/FreeDeliveryQuery'));
const FreeDeliveryModify = loadable(() => import('./freeDeliveryQuery/freeDeliveryModify/FreeDeliveryModify'));

export const subRoutes = [
  {
    path: '/ImplantableDeliveryManagement',
    component: ImplantableDeliveryManagement
  },
  {
    path: '/ImplantableDeliveryDetailModify',
    component: ImplantableDeliveryDetailModify
  },
  {
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    path: '/StockupDeliveryQuery',
    component: StockupDeliveryQuery
  },
  {
    path: '/StockupDeliveryModify',
    component: StockupDeliveryModify
  },
  {
    path: '/akzxCstStatementConfirmationManagement',
    component: akzxCstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  { // M813251010 【安康】供应耗材管理
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    // M813253013供应商：植入性订单响应
    path: '/ImplantationOrderManagement',
    component: ImplantationOrderManagement
  },
  {
    // M813253009 植入性发货单管理明细编辑
    path: '/AKZXImplantableDeliveryDetailModify',
    component: AKZXImplantableDeliveryDetailModify
  },
  {
    // M813253014 供应商：植入性发货明细查询
    path: '/ImplantationDeliveryDetailQuery',
    component: ImplantationDeliveryDetailQuery
  },
  {
    // M813253019 (新版)植入性发货单管理
    path: '/AKZXImplantableDeliveryManagement',
    component: AKZXImplantableDeliveryManagement
  },
  {
    // M813000001 (安康)植入性手术查询
    path: '/OperationImplantationQuery',
    component: OperationImplantationQuery
  },
  {
    // M813000001：植入性手术查询明细编辑
    path: '/OperationImplantationDetailModify',
    component: OperationImplantationDetailModify
  },
  {
    // M813253001 买赠订单查询响应
    path: '/FreeOrderManagement',
    component: FreeOrderManagement
   },
   {
    // M813253002 买赠发货单管理
    path: '/FreeDeliveryQuery',
    component: FreeDeliveryQuery
   },
   {
    // M813253002 买赠发货单编辑
    path: '/FreeDeliveryModify',
    component: FreeDeliveryModify
   }
];
